/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module LicensingModule
 */

import {
    CUSTOM_ELEMENTS_SCHEMA,
    NgModule,
    NO_ERRORS_SCHEMA,
} from '@angular/core';

import {
    ClrInputModule,
    ClrRadioModule,
    ClrSpinnerModule,
    ClrWizardModule,
} from '@clr/angular';

import { AviCardModule, AviUsageBarModule } from 'nsx-alb-ui-components';
import { AviFormsModule } from 'ng/modules/avi-forms/avi-forms.module';
import { AviProxyModule } from 'ng/modules/avi-proxy/avi-proxy.module';
import { CommonModule } from '@angular/common';
import { CoreModule } from 'ng/modules/core/core.module';
import { DataGridModule } from 'ng/modules/data-grid/data-grid.module';
import { FormsModule } from '@angular/forms';
import { LetModule } from '@ngrx/component';
import { LicenseCardModule } from 'ng/modules/license-card/license-card.module';
import { SharedModule } from 'ng/shared/shared.module';

import {
    LicenseQuotaConfigComponent,
} from 'standalone-components/license-quota-config/license-quota-config.component';

import {
    AlbServicesSiteProvider,
    ClusterProvider,
    LicensePoolProvider,
    PortalInfoProvider,
    TenantItemProvider,
} from './ajs-upgraded-providers';

import { DialogModule } from '../dialog/dialog.module';
import { NotificationModule } from '../notification/notification.module';

import {
    ConnectToOnPremModalComponent,
    DisconnectCloudLicensingModalComponent,
    DisconnectOnPremLicensingModalComponent,
    LicenseAddPanelComponent,
    LicenseAddPanelModalComponent,
    LicenseDeleteDialogComponent,
    LicenseListComponent,
    LicenseSummaryCardComponent,
    LicenseTierSelectCardComponent,
    LicenseTierSwitchModalComponent,
    LicenseTierSwitchNotificationComponent,
    LicenseUsageCardComponent,
    LicensingGetStartedComponent,
    LicensingPageComponent,
    LicensingPageHeaderComponent,
    LicensingPageStatusCardComponent,
    LicensingPageStore,
    ProxyConfigModalComponent,
    TenantUsageListComponent,
} from './components';

const licensingComponents = [
    ConnectToOnPremModalComponent,
    DisconnectCloudLicensingModalComponent,
    DisconnectOnPremLicensingModalComponent,
    LicenseAddPanelComponent,
    LicenseAddPanelModalComponent,
    LicenseDeleteDialogComponent,
    LicenseListComponent,
    LicenseSummaryCardComponent,
    LicenseTierSelectCardComponent,
    LicenseTierSwitchModalComponent,
    LicenseTierSwitchNotificationComponent,
    LicenseUsageCardComponent,
    LicensingGetStartedComponent,
    LicensingPageComponent,
    LicensingPageHeaderComponent,
    LicensingPageStatusCardComponent,
    ProxyConfigModalComponent,
    TenantUsageListComponent,
];

/**
 * @description Angular Module for Licensing related services and components.
 * @author Zhiqian Liu, Deepak Chaudhary
 */
@NgModule({
    declarations: [
        ...licensingComponents,
    ],
    exports: [],
    providers: [
        AlbServicesSiteProvider,
        ClusterProvider,
        LicensePoolProvider,
        LicensingPageStore,
        PortalInfoProvider,
        TenantItemProvider,
    ],
    imports: [
        AviCardModule,
        AviFormsModule,
        AviProxyModule,
        AviUsageBarModule,
        ClrInputModule,
        ClrRadioModule,
        ClrSpinnerModule,
        ClrWizardModule,
        CommonModule,
        CoreModule,
        DataGridModule,
        DialogModule,
        FormsModule,
        LetModule,
        LicenseCardModule,
        LicenseQuotaConfigComponent,
        NotificationModule,
        SharedModule,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class LicensingModule { }
